export enum MemoViewOption {
    CHAT = "CHAT",
    PLANNING = "PLANNING",
    DEPENDENCIES = "DEPENDENCIES",
}
